<template>
  <section id="reports" class="reports">
    <div class="section-top-row">
      <div class="row row-narrow align-items-center no-print position-relative">
        <div class="col order-md-0 order-0">
          <h1>{{ $t('reports') }}</h1>
        </div>
        <div class="col-auto table-view-navigator order-md-1 order-1">
          <a class="btn btn-themed gray d-md-inline-flex d-block align-items-center excel-btn"
             @click="printPressed">
            <PrintSvg class="mr-2 file-svg"/>
            <span>{{ $t('print_noun') }}</span>
          </a>
        </div>
        <div class="col-auto order-md-2 order-2 table-view-navigator"
             v-if="excelEnabled">
          <a class="btn btn-themed gray d-md-inline-flex d-block align-items-center excel-btn"
             @click="excel">
            <ExcelSvg class="svg-gray mr-md-2"/>
            <span>{{ $t('excel') }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="sub-menu no-print">
      <template v-for="(m, mind) in menuFiltered">
        <router-link v-if="!m.right || rights.includes(m.right)"
                     :to="{ name: m.to }"
                     @mousedown="routerLinkClicked(m)"
                     :key="`settings-link-${mind}}`">
          {{ $t(m.title) }}
        </router-link>
      </template>
    </div>
    <!--    <div class="date-select" v-if="!['ReportsDebtors'].includes($route.name)">-->
    <div class="date-select">
      <div class="row mt-4 align-items-end row-narrow">
        <!--        <div class="col-md-2 col-6" v-if="!['ReportsDebtors', 'ReportsPL'].includes($route.name)">-->
        <div class="col-md-2 col-6" v-if="!['ReportsDebtors', 'ReportDepositBalances'].includes($route.name)">
          <DateGroup :label="$t(['ReportCashdesk'].includes($route.name) ? 'date' : 'date_from')"
                     :key="`from-${counter}`"
                     :min-date="minDate"
                     :required="true"
                     v-model="from"/>
        </div>
        <div :class="{ 'd-none': ['ReportCashdesk', 'ReportDepositBalances'].includes($route.name) }"
             class="col-md-2 col-6">
          <DateGroup :label="$t(['ReportsDebtors'].includes($route.name) ? 'date' : 'date_to')"
                     :key="`to-${counter}`"
                     :min-date="minDate"
                     :required="true"
                     v-model="to"/>
        </div>

        <div class="col-md-2 col-6" v-if="['ReportsPL__temp_hide'].includes($route.name)">
          <SelectGroup :label="$t('month')"
                       variant="white"
                       :null-option="false"
                       :options="monthsOptions"
                       v-model="selectedMonth"/>
        </div>
        <div class="col-md-2 col-6" v-if="['ReportsPL__temp_hide'].includes($route.name)">
          <SelectGroup :label="$t('year')"
                       variant="white"
                       :null-option="false"
                       :options="yearOptions"
                       v-model="selectedYear"/>
        </div>

        <div :class="{ 'd-none': !showNew }"
             class="col-md-auto col-12">
          <div class="mb-md-2 pb-md-1 no-print">
            <CheckboxGroup :label="$t('show_only_new_patients')"
                           v-model="onlyNew"
                           fid="onlyNew"/>
          </div>
        </div>
        <div :class="{ 'd-none': !showNew }"
             class="col-md-auto col-12">
          <div class="mb-md-2 pb-md-1 no-print">
            <CheckboxGroup :label="$t('hide_cancelled_visits')"
                           v-model="hideCancelled"
                           fid="hideCancelled"/>
          </div>
        </div>
        <div class="col-12" v-if="['ReportsSalaries'].includes($route.name)"></div>
        <div :class="{ 'd-none': !doctorsSearch || showDeletedDoctors }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('doctors')"
                              :dblclick="false"
                              model="doctor"
                              title="full_name"
                              :dbsearch="false"
                              :prepopulatedOptions="doctors"
                              v-model="selectedDoctors"/>
        </div>
        <div :class="{ 'd-none': !doctorsSearch || !showDeletedDoctors }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('doctors')"
                              :dblclick="false"
                              model="doctor"
                              title="full_name"
                              :dbsearch="true"
                              v-model="selectedDoctors"/>
        </div>
        <div :class="{ 'd-none': !chairsSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('chairs')"
                              :dblclick="false"
                              model="chair"
                              title="chair_name"
                              :dbsearch="false"
                              :prepopulatedOptions="chairs"
                              v-model="selectedChairs"/>
        </div>
        <div :class="{ 'd-none': !professionSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('profession')"
                              :dblclick="false"
                              model="profession"
                              title="title"
                              :dbsearch="true"
                              v-model="selectedProfessions"/>
        </div>
        <div :class="{ 'd-none': !hasMultipleBranches }"
             class="col-md-2 col-12"
             v-if="bLoaded">
          <ServiceMultiSelect :label="$t('branch')"
                              :dblclick="false"
                              model="branch"
                              title="title"
                              :dbsearch="false"
                              :prepopulatedOptions="branches"
                              v-model="selectedBranches"/>
        </div>
        <div :class="{ 'd-none': !oneDoctorsSearch }"
             class="col-md-2 col-12">
          <SelectGroup :options="doctors"
                       title="full_name"
                       :label="$t('doctor')"
                       :showlabel="true"
                       variant="white"
                       v-model="oneDoctor"/>
        </div>
        <div :class="{ 'd-none': !oneTechnicSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('technic')"
                              :dblclick="false"
                              model="technic"
                              title="title"
                              :multiple="false"
                              :dbsearch="true"
                              :autocompleteAdditionalParams="{ 'branch_id': branch }"
                              v-model="oneTechnic"/>
        </div>
        <div :class="{ 'd-none': !oneAssistantSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('assistant')"
                              :dblclick="false"
                              model="doctor_assistant"
                              title="title"
                              :multiple="false"
                              :dbsearch="true"
                              :autocompleteAdditionalParams="{ 'branch_id': branch }"
                              v-model="oneAssistant"/>
        </div>
        <div :class="{ 'd-none': !oneAdministratorSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('administrator')"
                              :dblclick="false"
                              model="administrator"
                              title="title"
                              :multiple="false"
                              :autocompleteAdditionalParams="{ 'branch_id': branch }"
                              :dbsearch="true"
                              v-model="oneAdministrator"/>
        </div>
        <div :class="{ 'd-none': !oneCuratorSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('curator')"
                              :dblclick="false"
                              model="curator"
                              title="title"
                              :multiple="false"
                              :dbsearch="true"
                              :autocompleteAdditionalParams="{ 'branch_id': branch }"
                              v-model="oneCurator"/>
        </div>
        <div :class="{ 'd-none': !curatorsSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('curators')"
                              :dblclick="false"
                              model="curator"
                              title="full_name"
                              :dbsearch="true"
                              v-model="selectedCurators"/>
        </div>
        <div :class="{ 'd-none': !oneStaffSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="['ReportSaleOfGoods'].includes($route.name) ? $t('employee') : $t('who_created')"
                              :dblclick="false"
                              model="staff"
                              title="title"
                              :multiple="false"
                              :dbsearch="true"
                              v-model="oneStaff"/>
        </div>
        <div :class="{ 'd-none': !f57Search }"
             class="col-md-2 col-12">
          <SelectGroup :options="f057Types"
                       :label="$t('type')"
                       :showlabel="true"
                       :null-option="false"
                       variant="white"
                       v-model="f57Type"/>
        </div>
        <div :class="{ 'd-none': !bonusOperationTypeSearch }"
             class="col-md-2 col-12">
          <SelectGroup :options="bonusOperationTypes"
                       :label="$t('type')"
                       :showlabel="true"
                       :null-option="true"
                       variant="white"
                       v-model="bonusOperationType"/>
        </div>
        <div :class="{ 'd-none': !diagnosesSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('diagnoses')"
                              :dblclick="false"
                              model="diagnosis_template"
                              title="title"
                              :dbsearch="true"
                              v-model="diagnoses"/>
        </div>
        <div :class="{ 'd-none': !patientsSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('patients')"
                              :dblclick="false"
                              model="patient"
                              title="full_name"
                              :dbsearch="true"
                              v-model="patients"/>
        </div>
        <div :class="{ 'd-none': !familyAccountSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('family_account')"
                              :dblclick="false"
                              model="patient"
                              title="full_name"
                              :dbsearch="true"
                              v-model="familyAccounts"/>
        </div>
        <div :class="{ 'd-none': !warehousesSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('warehouses')"
                              :dblclick="false"
                              model="warehouse"
                              title="title"
                              :autocompleteAdditionalParams="{ 'branch_id': branch, 'deleted_at': 'whereNull' }"
                              :dbsearch="true"
                              v-model="warehouses"/>
        </div>
        <div :class="{ 'd-none': !materialsSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('materials')"
                              :dblclick="false"
                              model="material"
                              title="title"
                              :dbsearch="true"
                              v-model="materials"/>
        </div>
        <div :class="{ 'd-none': !servicesSearch }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('services')"
                              :dblclick="false"
                              v-model="services"/>
        </div>
        <div :class="{ 'd-none': !showCategories }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('categories')"
                              :dblclick="false"
                              model="service_category"
                              title="title"
                              :per-page="36"
                              :dbsearch="true"
                              v-model="categories"/>
        </div>
        <div :class="{ 'd-none': !showMaterialCategories }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('categories')"
                              :dblclick="false"
                              model="materialgroup"
                              title="title"
                              :dbsearch="true"
                              v-model="materialCategories"/>
        </div>
        <div :class="{ 'd-none': !showSources }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('source')"
                              :dblclick="false"
                              model="client_source"
                              title="title"
                              :per-page="36"
                              :dbsearch="true"
                              v-model="sources"/>
        </div>
        <div :class="{ 'd-none': !showInsuranceCompanies }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('insurance_company')"
                              :dblclick="false"
                              model="insurance_company"
                              title="title"
                              :dbsearch="true"
                              v-model="insuranceCompanies"/>
        </div>
        <div :class="{ 'd-none': !showChannels }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('channels')"
                              :dblclick="false"
                              model="client_source"
                              title="title"
                              :dbsearch="true"
                              v-model="channels"/>
        </div>
        <div :class="{ 'd-none': !showDepositAccounts }"
             v-if="depositAccountOptions.length"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('deposit_accounts')"
                              :dblclick="false"
                              model="deposit_account"
                              title="title"
                              :dbsearch="false"
                              :prepopulatedOptions="depositAccountOptions"
                              v-model="depositAccounts"/>
        </div>
        <div :class="{ 'd-none': !showPayMethods }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('pay_methods')"
                              :dblclick="false"
                              model="pay_method"
                              :key="`pay-method-${route.name}`"
                              title="translatedTitle"
                              :prepopulated-options="finalPayMethods"
                              :allow-empty="route.name !== 'ReportCashdesk'"
                              :dbsearch="false"
                              v-model="payMethods"/>
        </div>
        <div :class="{ 'd-none': !showFields }"
             class="col-md-2 col-12">
          <ServiceMultiSelect :label="$t('fields')"
                              :dblclick="false"
                              model="field"
                              title="translatedTitle"
                              :dbsearch="true"
                              v-model="fields"/>
        </div>
        <div :class="{ 'd-none': !showDeletedDoctorsSearch }"
             class="col-md-2 col-12">
          <CheckboxGroup fid="showdeleteddoctors"
                         :label="$t('show_deleted_doctors')"
                         class="deleted-checkbox"
                         v-model="showDeletedDoctors"/>
        </div>
        <div :class="{ 'd-none': !showOnlyPaid }"
             class="col-md-2 col-12">
          <CheckboxGroup fid="onlypaid"
                         :label="$t('only_paid')"
                         class="deleted-checkbox"
                         v-model="onlyPaid"/>
        </div>
        <div :class="{ 'd-none': !showFiscalCheque }"
             class="col-md-2 col-12">
          <CheckboxGroup fid="fiscalCheque"
                         :label="$t('fiscal_cheque')"
                         class="deleted-checkbox"
                         v-model="fiscalCheque"/>
        </div>
        <div :class="{ 'd-none': !showBlocksAsFreeTime }"
             class="col-md-auto col-12">
          <div class="mb-md-2 pb-md-1 no-print">
            <CheckboxGroup :label="$t('show_block_as_free_time')"
                           v-model="blocksAsFreeTime"
                           fid="blocksAsFreeTime"/>
          </div>
        </div>
        <div :class="{ 'd-none': !showWhichSourceToggle }"
             class="col-md-2 col-12">
          <div class="radio-inline">
            <RadioGroup :options="[
                  { id: 'visit', title: $t('visit') },
                  { id: 'patient', title: $t('patient') }
                ]"
                        :label="$t('source_type')"
                        :showlabel="true"
                        v-model="whichSource"
                        validationId="doctor_salaries_type"/>
          </div>
        </div>
        <div class="col-md-2 col-12">
          <div class="form-group no-print">
            <button @click="loadReport"
                    :disabled="reportLoading"
                    class="search-button btn btn-themed btn-themed-squared">
              {{ $t('apply') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <router-view v-slot="{ Component }"
                 :from="from"
                 :to="to"
                 :month="selectedMonth"
                 :year="selectedYear"
                 @updateFrom="updateFrom"
                 @updateTo="updateTo"
                 v-if="bLoaded"
                 :oneDoctor="parseInt(oneDoctor)"
                 :oneTechnic="oneTechnic"
                 :oneAssistant="oneAssistant"
                 :oneAdministrator="oneAdministrator"
                 :oneCurator="oneCurator"
                 :oneStaff="oneStaff"
                 :f57Type="f57Type"
                 :onlyNew="onlyNew"
                 :onlyPaid="onlyPaid"
                 :hideCancelled="hideCancelled"
                 :doctors="selectedDoctors"
                 :curators="selectedCurators"
                 :showDeletedDoctors="showDeletedDoctors"
                 :blocksAsFreeTime="blocksAsFreeTime"
                 :chairs="selectedChairs"
                 :fields="fields"
                 :selectedBranches="selectedBranches.map(x => x.id)"
                 :selectedProfessions="selectedProfessions.map(x => x.code)"
                 :insuranceCompanies="insuranceCompanies"
                 :diagnoses="diagnoses"
                 :services="services"
                 :patients="patients"
                 :familyAccounts="familyAccounts"
                 :bonusOperationType="bonusOperationType"
                 :warehouses="warehouses"
                 :materials="materials"
                 :materialCategories="materialCategories"
                 :fiscalCheque="fiscalCheque"
                 :payMethods="payMethods"
                 :depositAccounts="depositAccounts"
                 :sources="sources"
                 :channels="channels"
                 :categories="categories"
                 @selectCurrentUser="selectCurrentUser"
                 @cleanPayMethods="payMethods = []"
                 :whichSource="whichSource"
    >
      <component ref="childRouterView" :is="Component" />
    </router-view>
  </section>
</template>

<script setup>
import DateGroup from '@/components/form/DateGroup'
import moment from 'moment'
import ExcelSvg from '@/assets/svg-vue/general/excel.svg'
import ServiceMultiSelect from "@/components/form/ServiceMultiSelect"
import SelectGroup from "@/components/form/SelectGroup"
import PrintSvg from '@/assets/svg-vue/general/print.svg'
import { useStore} from "vuex"
import { bonusOperationTypes, countries, f057Types } from "@/dictionaries/dictionary"
import CheckboxGroup from "@/components/form/CheckboxGroup"
import RadioGroup from "@/components/form/RadioGroup.vue"
import {capitalize, computed, onMounted, ref, watch} from "vue"
import {useRoute, useRouter} from "vue-router"

const store = useStore()
const route = useRoute()
const router = useRouter()

const menu = ref([
  { to: 'ReportDay', title: 'daily_report', right: 'reports_day' },
  { to: 'ReportsPL', title: 'pl_statement', right: 'reports_pnl' },
  { to: 'ReportsCashFlows', title: 'cash_flow_statement', right: 'reports_cash' },
  { to: 'ReportCashdesk', title: 'cashdesk_report', right: 'reports_cashdesk' },
  { to: 'ReportsDebtors', title: 'debtors_statement', right: 'reports_debtors' },
  { to: 'ReportsVisits', title: 'visits', right: 'reports_visits' },
  { to: 'ReportsVisitsDetailed', title: 'visits_detailed', right: 'reports_visits' },
  { to: 'ReportsPatients', title: 'patients', right: 'reports_patients' },
  { to: 'ReportsDiagnoses', title: 'diagnoses', right: 'reports_diagnoses' },
  { to: 'ReportsSalaries', title: 'salaries', right: 'reports_salaries' },
  { to: 'ReportsIncomeByDoctors', title: 'income_by_doctors', right: 'reports_doctors_revenues' },
  { to: 'ReportsIncomeByServices', title: 'income_by_services', right: 'reports_services_revenues' },
  { to: 'ReportsCancelledVisits', title: 'cancelled_visits', right: 'reports_cancelled' },
  { to: 'ReportsMaterials', title: 'materials', right: 'reports_materials' },
  { to: 'ReportsServices', title: 'services', right: 'reports_services' },
  { to: 'Report57', title: 'f057', right: 'reports_57' },
  { to: 'ReportStatVisits', title: 'visit_statistics', right: 'reports_stat_visits' },
  { to: 'ReportStatAdmins', title: 'admin_statistics_future', right: 'reports_stat_admins' },
  { to: 'ReportStatDoctors', title: 'doctor_statistics', right: 'reports_stat_doctors' },
  { to: 'ReportDoctorsLoad', title: 'doctors_load', right: 'reports_doctors_load' },
  { to: 'ReportDoctorsConversion', title: 'doctors_conversion', right: 'reports_doctors_conversion' },
  { to: 'ReportGuarantee', title: 'warranty_case', right: 'reports_warranty_case' },
  { to: 'ReportCRMAnalytics', title: 'crm_leads_analytics', right: 'reports_crm_analytics' },
  { to: 'ReportVisitSourceAnalytics', title: 'visits_by_source', right: 'reports_visit_source' },
  { to: 'ReportsMaterialsMovement', title: 'materials_movement_analytics', right: 'reports_materials_movement_analytics' },
  { to: 'ReportInsurance', title: 'insurance', right: 'report_insurance' },
  { to: 'ReportBonuses', title: 'bonuses', right: 'report_bonuses' },
  { to: 'ReportDeletedPayments', title: 'payments_registry', right: 'report_deleted_payments' },
  { to: 'ReportPatientsConversion', title: 'patients_conversion', right: 'reports_patients_conversion' },
  { to: 'ReportSaleOfGoods', title: 'sale_of_goods', right: 'cashregister_sell_goods' },
  { to: 'ReportDepositMovements', title: 'deposit_movements', right: 'report_deposit_movements' },
  { to: 'ReportDepositBalances', title: 'patient_deposits', right: 'report_deposit_balances' },
])
const selectedDoctors = ref([])
const selectedChairs = ref([])
const selectedProfessions = ref([])
const selectedCurators = ref([])
const oneDoctor = ref(null)
const oneTechnic = ref(null)
const oneAssistant = ref(null)
const oneAdministrator = ref(null)
const oneCurator = ref(null)
const oneStaff = ref(null)
const insuranceCompanies = ref([])
const showDeletedDoctors = ref(false)
const blocksAsFreeTime = ref(true)
const patients = ref([])
const familyAccounts = ref([])
const diagnoses = ref([])
const services = ref([])
const categories = ref([])
const materialCategories = ref([])
const depositAccounts = ref([])
const sources = ref([])
const channels = ref([])
const fields = ref([])
const warehouses = ref([])
const materials = ref([])
const payMethods = ref([])
const whichSource = ref('visit')
const f57Type = ref('therapist')
const bonusOperationType = ref(null)
const counter = ref(1)
const onlyNew = ref(false)
const hideCancelled = ref(true)
const onlyPaid = ref(false)
const fiscalCheque = ref(false)
const reportLoading = ref(false)
const bLoaded = ref(false)
const childRouterView = ref(null)
const from = ref(moment().clone().startOf('month').format('YYYY-MM-DD'))
const to = ref(moment().clone().format('YYYY-MM-DD'))
const selectedBranches = ref([])
const selectedMonth = ref(moment().month() + 1)
const selectedYear = ref(moment().year())

const doctors = computed(() => store.state.auth.doctors_with_blocked)
const chairs = computed(() => store.state.auth.chairs)
const rights = computed(() => store.state.auth.rights)
const branches = computed(() => store.state.auth.branches)
const branch = computed(() => store.state.auth.branch)
const clinic = computed(() => store.state.auth.clinic)
const user = computed(() => store.state.auth.user)
const depositAccountOptions = computed(() => store.state.auth.deposit_accounts)
const pay_methods = computed(() => store.state.auth.pay_methods)
const finalPayMethods = computed(() => {
  let toExclude = [100]
  if(route.name === 'ReportCashdesk') {
    toExclude = [0, 5, 6, 7, 100]
  }
  return pay_methods.value.filter(x => !toExclude.includes(Number(x.id)) && x.custom_data_active)
})
const doctorsSearch = computed(() => {
  return [
    'ReportsDiagnoses',
    'ReportsVisits',
    'ReportsVisitsDetailed',
    'ReportsIncomeByDoctors',
    'ReportsIncomeByServices',
    'ReportsServices',
    'ReportStatDoctors',
    'ReportStatVisits',
    'ReportDoctorsLoad',
    'ReportGuarantee',
    'ReportCRMAnalytics',
    'ReportsMaterials',
    'ReportVisitSourceAnalytics',
    'ReportDoctorsConversion',
    'ReportInsurance'
  ].includes(route.name)
})
const curatorsSearch = computed(() => ['ReportsVisits', 'ReportStatVisits'].includes(route.name))
const monthsOptions = computed(() => {
  return Array.from({ length: 12 }, (_, i) => ({
    id: i + 1,
    title: capitalize(moment().month(i).format("MMMM"))
  }))
})

const yearOptions = computed(() => {
  return Array.from({ length: 4 }, (_, i) => {
    const year = moment().year() - i
    return {
      id: year,
      title: String(year)
    }
  })
})

const chairsSearch = computed(() => ['ReportStatVisits', 'ReportDoctorsLoad', 'ReportDoctorsConversion'].includes(route.name))
const oneDoctorsSearch = computed(() => (['ReportsSalaries'].includes(route.name) && canSeeOthersSalaries.value) || ['Report57'].includes(route.name))
const oneTechnicSearch = computed(() => ['ReportsSalaries'].includes(route.name) && canSeeOthersSalaries.value)
const oneAssistantSearch = computed(() => ['ReportsSalaries'].includes(route.name) && canSeeOthersSalaries.value)
const oneAdministratorSearch = computed(() => ['ReportsSalaries'].includes(route.name) && canSeeOthersSalaries.value)
const oneCuratorSearch = computed(() => ['ReportsSalaries'].includes(route.name) && canSeeOthersSalaries.value)
const oneStaffSearch = computed(() => ['ReportStatVisits', 'ReportVisitSourceAnalytics', 'ReportBonuses', 'ReportSaleOfGoods'].includes(route.name))
const professionSearch = computed(() => ['ReportDoctorsLoad', 'ReportDoctorsConversion'].includes(route.name))
const servicesSearch = computed(() => ['ReportsServices', 'ReportInsurance'].includes(route.name))
const diagnosesSearch = computed(() => ['ReportsDiagnoses'].includes(route.name))
const f57Search = computed(() => ['Report57'].includes(route.name))
const bonusOperationTypeSearch = computed(() => ['ReportBonuses'].includes(route.name))
const patientsSearch = computed(() => {
  return [
    'ReportsVisits',
    'ReportsVisitsDetailed',
    'ReportsServices',
    'ReportGuarantee',
    'ReportInsurance',
    'ReportsCashFlows',
    'ReportBonuses',
    'ReportSaleOfGoods',
    'ReportDepositBalances',
    'ReportDepositMovements'
  ].includes(route.name)
})
const familyAccountSearch = computed(() => ['ReportDepositMovements'].includes(route.name))
const warehousesSearch = computed(() => ['ReportsMaterials', 'ReportsMaterialsMovement'].includes(route.name))
const materialsSearch = computed(() => ['ReportsMaterials', 'ReportsMaterialsMovement', 'ReportSaleOfGoods'].includes(route.name))
const excelEnabled = computed(() => !['ReportDay', 'Report57'].includes(route.name))
const showNew = computed(() => ['ReportsPatients'].includes(route.name))
const showBlocksAsFreeTime = computed(() => ['ReportDoctorsLoad'].includes(route.name))
const showOnlyPaid = computed(() => ['ReportInsurance'].includes(route.name))
const showFiscalCheque = computed(() => ['ReportsCashFlows'].includes(route.name))
const showDeletedDoctorsSearch = computed(() => ['ReportsIncomeByDoctors'].includes(route.name))
const showCategories = computed(() => ['ReportsServices'].includes(route.name))
const showMaterialCategories = computed(() => ['ReportsMaterialsMovement', 'ReportSaleOfGoods'].includes(route.name))
const showSources = computed(() => ['ReportCRMAnalytics', 'ReportVisitSourceAnalytics', 'ReportPatientsConversion'].includes(route.name))
const showInsuranceCompanies = computed(() => ['ReportInsurance'].includes(route.name))
const showChannels = computed(() => ['ReportCRMAnalytics'].includes(route.name))
const showDepositAccounts = computed(() => ['ReportDepositBalances', 'ReportDepositMovements'].includes(route.name))
const showPayMethods = computed(() => ['ReportCashdesk', 'ReportsCashFlows'].includes(route.name))
const showFields = computed(() => {
  return [
    'ReportCRMAnalytics',
    'ReportVisitSourceAnalytics',
    'ReportDoctorsConversion'
  ].includes(route.name)
})
const showWhichSourceToggle = computed(() => ['ReportVisitSourceAnalytics'].includes(route.name))
const hasMultipleBranches = computed(() => false)
const daysLimit = computed(() => user.value?.user_additional?.report_days_limit || null)
const minDate = computed(() => daysLimit.value === null ? null : moment().subtract(daysLimit.value, 'days').format('YYYY-MM-DD'))
const menuFiltered = computed(() => {
  return menu.value.filter(item => {
    if (item.to === 'Report57' && clinic.value.country_id !== countries.KAZAKHSTAN) {
      return false
    }
    return item
  })
})
const canSeeOthersSalaries = computed(() => user.value?.user_additional?.see_others_salaries)

const excel = async () => {
  reportLoading.value = true
  if(childRouterView.value) {
    await childRouterView.value.excel()
  }
  reportLoading.value = false
}

const loadReport = async () => {
  reportLoading.value = true
  if(childRouterView.value) {
    await childRouterView.value.loadReport()
  }
  reportLoading.value = false
}

const printPressed = () => {
  if (window) window.print()
}

const populateDates = (_route = null) => {
  if(!_route) _route = route.name
  if(_route === 'ReportsPL') {
    from.value = moment().clone().startOf('month').format('YYYY-MM-DD')
  } else {
    from.value = moment().clone().format('YYYY-MM-DD')
  }
  to.value = moment().clone().format('YYYY-MM-DD')
  counter.value++
}

const routerLinkClicked = (m) => {
  populateDates(m.to)
}

const updateFrom = (val) => {
  from.value = val
}

const updateTo = (val) => {
  to.value = val
}

const selectCurrentUser = () => {
  if(!canSeeOthersSalaries.value) {
    switch(user.value.role_id) {
      case 3:
        oneAdministrator.value = user.value
        break
      case 4:
        oneDoctor.value = user.value.id
        break
      case 6:
        oneTechnic.value = user.value
        break
      case 7:
        oneAssistant.value = user.value
        break
      case 8:
        this.oneCurator.value = user.value
        break
    }
  }
}

onMounted(() => {
  populateDates()
  if(route.name === 'ReportsGeneral') {
    const redirects = [
      { right: 'reports_day', route: 'ReportDay' },
      { right: 'reports_pnl', route: 'ReportsPL' },
      { right: 'reports_cash', route: 'ReportsCashFlows' },
      { right: 'reports_cash', route: 'ReportsCashdesk' },
      { right: 'reports_debtors', route: 'ReportsDebtors' },
      { right: 'reports_visits', route: 'ReportsVisits' },
      { right: 'reports_visits', route: 'ReportsVisitsDetailed' },
      { right: 'reports_patients', route: 'ReportsPatients' },
      { right: 'reports_diagnoses', route: 'ReportsDiagnoses' },
      { right: 'reports_salaries', route: 'ReportsSalaries' },
      { right: 'reports_doctors_revenues', route: 'ReportsIncomeByDoctors' },
      { right: 'reports_services_revenues', route: 'ReportsIncomeByServices' },
      { right: 'reports_cancelled', route: 'ReportsCancelledVisits' },
      { right: 'reports_materials', route: 'ReportsMaterials' },
      { right: 'reports_services', route: 'ReportsServices' },
      { right: 'reports_57', route: 'Report57' },
      { right: 'reports_stat_visits', route: 'ReportStatVisits' },
      { right: 'reports_stat_admins', route: 'ReportStatAdmins' },
      { right: 'reports_stat_doctors', route: 'ReportStatDoctors' },
      { right: 'reports_doctors_load', route: 'ReportDoctorsLoad' },
      { right: 'reports_warranty_case', route: 'ReportGuarantee' },
      { right: 'reports_materials_movement_analytics', route: 'ReportsMaterialsMovement' },
      { right: 'reports_crm_analytics', route: 'ReportCRMAnalytics' },
      { right: 'reports_visit_source', route: 'ReportVisitSourceAnalytics' },
      { right: 'report_insurance', route: 'ReportInsurance' },
      { right: 'report_bonuses', route: 'ReportBonuses' },
      { right: 'payments', route: 'ReportDeletedPayments' },
      { right: 'reports_patients_conversion', route: 'ReportPatientsConversion' },
      { right: 'report_deposit_movements', route: 'ReportDepositMovements' },
      { right: 'report_deposit_balances', route: 'ReportDepositBalances' },
    ]
    let redirected = false
    redirects.forEach(item => {
      if(!redirected && rights.value.includes(item.right)) {
        router.push({name: item.route}).catch(()=>{})
        redirected = true
      }
    })
  }


  selectedBranches.value = [branches.value.find(x => Number(x.id) === Number(branch.value))]
  payMethods.value = finalPayMethods.value.filter(obj => obj.id === 1)
  bLoaded.value = true
})

watch([payMethods, () => route.name], ([val, routeName]) => {
  if(routeName !== 'ReportCashdesk' || val?.length) return
  payMethods.value = finalPayMethods.value.filter(obj => obj.id === 1)
})

watch(oneDoctor, (val) => {
  if(val) {
    oneTechnic.value = null
    oneAssistant.value = null
    oneAdministrator.value = null
    oneCurator.value = null
  }
})

watch(oneTechnic, (val) => {
  if(val) {
    oneDoctor.value = null
    oneAssistant.value = null
    oneAdministrator.value = null
    oneCurator.value = null
  }
})

watch(oneAssistant, (val) => {
  if(val) {
    oneTechnic.value = null
    oneDoctor.value = null
    oneAdministrator.value = null
    oneCurator.value = null
  }
})

watch(oneAdministrator, (val) => {
  if(val) {
    oneTechnic.value = null
    oneAssistant.value = null
    oneDoctor.value = null
    oneCurator.value = null
  }
})

watch(oneCurator, (val) => {
  if(val) {
    oneTechnic.value = null
    oneDoctor.value = null
    oneAssistant.value = null
    oneAdministrator.value = null
  }
})
</script>

<style scoped lang="scss">
.search-button {
  height: 46px;
  display: inline-block;
}
.deleted-checkbox {
  padding-bottom: 11px;
}
@media screen and (max-width: 768px) {
  .search-button {
    height: 32px;
    width: 100%;
  }
  .deleted-checkbox {
    padding-bottom: 0;
  }
}
</style>
